module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/employee/Children.ejs -->\n<div >\n';
 _.each(model.get('children'), function(child, index){ 
__p+='\n<div class="js-ext-child">\n    <label class="col-sm-1 col-sm-offset-3 control-label">\n        '+
((__t=( index + 1 ))==null?'':_.escape(__t))+
'\n    </label>\n    <div class="col-sm-6">\n        <select class="form-control m-b js-ext" name="childType">\n            <option value=""\n                '+
((__t=( !child.category ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n                None of the Categories Below\n            </option>\n            <option value="underage"\n                '+
((__t=( (child.category === 'underage') ?
                    'selected' : '' ))==null?'':_.escape(__t))+
'>\n                Under 18 or In Education\n            </option>\n            <option value="inEducation"\n                '+
((__t=( (child.category === 'inEducation') ?
                    'selected' : ''  ))==null?'':_.escape(__t))+
'>\n                Over 18 - In Education (Diploma level)\n            </option>\n            <option value="inHigherEducation"\n                '+
((__t=( (child.category === 'inHigherEducation') ?
                    'selected' : '' ))==null?'':_.escape(__t))+
'>\n                Over 18 - In Education (Degree level or higher)\n            </option>\n            <option value="disabled"\n                '+
((__t=( (child.category === "disabled") ?
                    'selected' : '' ))==null?'':_.escape(__t))+
'>\n                Disabled\n            </option>\n            <option value="disabledInEducation"\n                '+
((__t=( (child.category === "disabledInEducation") ?
                    'selected' : '' ))==null?'':_.escape(__t))+
'>\n                Disabled - In Higher Education\n            </option>\n        </select>\n    </div>\n    <div class="col-sm-2">\n        <select class="form-control js-ext" name="pcbDeduction"\n                data-value-type="integer">\n            <option value="0" '+
((__t=( (child.pcbDeduction == 0) ?
                    'selected' : '' ))==null?'':_.escape(__t))+
'>\n                0%\n            </option>\n            <option value="50" '+
((__t=( (child.pcbDeduction == 50) ?
                    'selected' : '' ))==null?'':_.escape(__t))+
'>\n                50%\n            </option>\n            <option value="100" '+
((__t=( (child.pcbDeduction == 100) ?
                    'selected' : '' ))==null?'':_.escape(__t))+
'>\n                100%\n            </option>\n        </select>\n        <span class="error error-pcbDeduction"></span>\n    </div>\n</div>\n';
 }) 
__p+='\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/employee/Children.ejs
// module id = 789
// module chunks = 1